import Vue from 'vue';
import { SECTION_TYPES } from '@/content/values/sections';

export const ObjectIconFilter = Vue.filter('objectIcon', (value) => {
  let icon = '';
  if(SECTION_TYPES[value]) {
    icon = SECTION_TYPES[value].icon;
  }
  return icon;
});